import { ElementRef, Injectable, ViewContainerRef } from '@angular/core';
import { LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class StandardModalService {
  constructor(private modalService: LaunchDialogService) {}

  openDialog(caller: LAUNCH_CALLER | string, openElement?: ElementRef, vcr?: ViewContainerRef, data?: any) {
    return this.modalService.openDialog(caller, openElement, vcr, data);
  }

  closeDialog(reason?: any) {
    this.modalService.closeDialog(reason || 'close');
  }

  getModalData() {
    return this.modalService.data$;
  }

  getClosedModalData() {
    return this.modalService.dialogClose;
  }
}
